import { Helmet } from "react-helmet";
import { Toaster } from "react-hot-toast";

const darkThemeMq = window.matchMedia("(prefers-color-scheme: dark)");

export default function App() {
  return (
    <>
      <Toaster
        position="top-right"
        reverseOrder={false}
      />
      <Helmet>
        {darkThemeMq.matches ? (
          <link rel="icon" href="/favicon.ico" />
        ) : (
          <link rel="icon" href="/faviconLight.png" />
        )}
      </Helmet>
    </>
  )
}